import script from "./SalaryAdvanceRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryAdvanceRequest.vue?vue&type=script&setup=true&lang=js"

import "./SalaryAdvanceRequest.vue?vue&type=style&index=0&id=77ae035b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ae035b"]])

export default __exports__